/**
 * Mobile Menu
 * Handles mobile hamburger menu overlay with accessibility features
 */

jQuery(document).ready(function($) {
    const $menuButton = $('.header__menu-button');
    const $overlay = $('.header__mobile-overlay');

    // Guard clause: exit if elements don't exist
    if ($menuButton.length === 0 || $overlay.length === 0) {
        return;
    }

    let previouslyFocused = null;

    /**
     * Open the mobile menu overlay
     */
    function openMenu() {
        // Store previously focused element
        previouslyFocused = document.activeElement;

        // Add open/active classes
        $overlay.addClass('is-open');
        $menuButton.addClass('is-active');
        $('body').addClass('is-modal');

        // Update ARIA attributes
        $overlay.attr('aria-hidden', 'false');
        $menuButton.attr('aria-expanded', 'true');

        // Focus first menu item for keyboard users only
        setTimeout(function() {
            if (document.documentElement.getAttribute('data-whatintent') === 'keyboard') {
                const $focusableElements = $overlay.find('a[href]').filter(':visible');
                if ($focusableElements.length > 0) {
                    $focusableElements.first().focus();
                }
            }
        }, 50);
    }

    /**
     * Close the mobile menu overlay
     */
    function closeMenu() {
        // Remove open/active classes
        $overlay.removeClass('is-open');
        $menuButton.removeClass('is-active');
        $('body').removeClass('is-modal');

        // Update ARIA attributes
        $overlay.attr('aria-hidden', 'true');
        $menuButton.attr('aria-expanded', 'false');

        // Return focus for keyboard users only
        if (previouslyFocused && document.documentElement.getAttribute('data-whatintent') === 'keyboard') {
            previouslyFocused.focus();
        }
        previouslyFocused = null;
    }

    /**
     * Toggle menu state
     */
    function toggleMenu() {
        if ($overlay.hasClass('is-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    // Toggle menu on button click
    $menuButton.on('click', function(e) {
        e.preventDefault();
        toggleMenu();
    });

    // Close menu when any menu link is clicked
    $overlay.on('click', 'a', function() {
        closeMenu();
    });

    // Close menu on ESC key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $overlay.hasClass('is-open')) {
            closeMenu();
        }
    });

    // Focus trap: Handle Tab key when overlay is open
    $(document).on('keydown', function(e) {
        if (!$overlay.hasClass('is-open')) {
            return;
        }

        if (e.key === 'Tab') {
            const $focusableElements = $overlay.find('a[href]').filter(':visible');

            if ($focusableElements.length === 0) {
                return;
            }

            const firstFocusable = $focusableElements.first()[0];
            const lastFocusable = $focusableElements.last()[0];
            const currentFocused = document.activeElement;

            // Shift+Tab on first element: cycle to last
            if (e.shiftKey && currentFocused === firstFocusable) {
                e.preventDefault();
                lastFocusable.focus();
            }
            // Tab on last element: cycle to first
            else if (!e.shiftKey && currentFocused === lastFocusable) {
                e.preventDefault();
                firstFocusable.focus();
            }
        }
    });
});
